import {
  SvgIcon as MuiSvgIcon,
  SvgIconProps as MuiSvgIconProps,
} from "@mui/material";

export const PendingPersonIcon = (props: MuiSvgIconProps) => (
  <MuiSvgIcon {...props} data-testid="pending-person-icon">
    <path
      d="M8 8C10.21 8 12 6.21 12 4C12 1.79 10.21 0 8 0C5.79 0 4 1.79 4 4C4 6.21 5.79 8 8 8ZM8 10C5.33 10 0 11.34 0 14V15C0 15.55 0.45 16 1 16H15C15.55 16 16 15.55 16 15V14C16 11.34 10.67 10 8 10Z"
      fill="var(--gravx-color-neutral-on-light-grey-6)"
    />

  </MuiSvgIcon>
);
